var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 7.8646,
    fill: "#00389C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7803 13.2549L11.1079 16.9967L15.5371 20.3301L19.3532 17.0926L21.4972 17.807L20.8473 18.9069L25.3067 23.3556L21.0857 26.2523H15.5968L9.41083 19.5436L5 16L11 10L14.7803 13.2549Z",
    fill: "#FFFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4817 13.3577L14.1327 16.7701L15.4623 17.7707L18.9177 14.8394L24.4789 16.6925L23.3591 18.5876L26.1744 21.3962L26.836 19.5436L32 16L26 10L21.8698 13.3577H17.4817Z",
    fill: "#FFFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeal);
export default __webpack_public_path__ + "static/media/deal.a410bbff0a8db48df0165465731d02f1.svg";
export { ForwardRef as ReactComponent };